import {
  calculateCoverageFromSalesFactor,
  calculateSalesFactorFromDG,
  dateFromString,
} from '@retail/utils';
import { CalculusConditionDTO } from '../../dtos';
import { ConditionBaseProps, ItemConditionBase } from '../ConditionBase';
import { SupplierBase } from '@retail/suppliers/types';

export interface MarkupConditionProps extends ConditionBaseProps<MarkupCondition> {
  markupCostFactor?: number;
  coverageDegree?: number;
  markupCoverageDegree?: number;
  salesFactor?: number;
  markupSalesFactor?: number;
}

export class MarkupCondition extends ItemConditionBase<MarkupCondition> {
  markupCostFactor?: number;
  coverageDegree?: number;
  markupCoverageDegree?: number;
  salesFactor?: number;
  markupSalesFactor?: number;

  constructor({
    markupCostFactor,
    coverageDegree,
    salesFactor,
    markupCoverageDegree,
    markupSalesFactor,
    ...superProps
  }: MarkupConditionProps) {
    super(superProps);
    this.markupCostFactor = markupCostFactor;
    this.coverageDegree = coverageDegree;
    this.salesFactor = salesFactor;
    this.markupCoverageDegree = markupCoverageDegree;
    this.markupSalesFactor = markupSalesFactor;
  }

  static fromDto = (dto: CalculusConditionDTO): MarkupCondition => {
    const markupCoverageDegree =
      dto.markupCoverageDegree ??
      (dto.markupSalesFactor && calculateCoverageFromSalesFactor(dto.markupSalesFactor));
    const markupSalesFactor =
      dto.markupSalesFactor ??
      (dto.markupCoverageDegree != null
        ? calculateSalesFactorFromDG(dto.markupCoverageDegree)
        : undefined);

    return new MarkupCondition({
      id: dto.id,
      assortmentId: dto.assortmentId,
      assortmentName: dto.assortmentName,
      inDraft: dto.inDraft,
      type: dto.type,
      supplier: dto.supplier ? SupplierBase.fromDto(dto.supplier) : undefined,
      bindingType: dto.bindingType,
      bindingTarget: dto.bindingTarget,
      bindingTargetName: dto.bindingTargetName,
      bindingTargetId: dto.bindingTargetId,
      bindingTargetItem: dto.bindingTargetItem,
      validFrom: new Date(dto.validFrom),
      validTo: dateFromString(dto.validTo),
      markupCostFactor: dto.markupCostFactor,
      markupCoverageDegree,
      markupSalesFactor,
      coverageDegree: dto.coverageDegree,
      salesFactor: dto.salesFactor,
    });
  };
}
